import gql from 'graphql-tag';

import { MatchesAlbumDetails } from '../fragments/album';
import {
  AlbumRootAlbumFolderBaseDetails,
  AlbumWatermarkConfig,
} from '../../../../../../../graphql/fragments/album';
import {
  WebGalleryAlbumAccessFields,
  WebGalleryAlbumBaseDetails,
  WebGalleryAlbumCustomPrintFields,
  WebGalleryAlbumPrices,
  WebGalleryAlbumPurchasedPhotoDownloads,
} from '../../../../../../web-gallery/graphql/fragments/album';
import { WebGalleryAccountDetailsWithImageAssets } from '../../../../../../web-gallery/graphql/fragments/account';
import { AutoContributorSettingsDetails } from '../../../../../../../graphql/fragments/contributor-assignments';
import { AlbumFolderPurchaseDetails } from '../../../../../../../graphql/fragments/album-folder';
import { DiscountTemplateDetails } from '../../../../../../../graphql/fragments/discount-templates';
import { AlbumFolderForPrintAssetDetails } from '../fragments/album-folder';

export const AlbumForMatches = gql`
  query AlbumForMatches($id: RecordID!) {
    album(id: $id) {
      ...MatchesAlbumDetails
      ...AlbumRootAlbumFolderBaseDetails
      ...WebGalleryAlbumCustomPrintFields
      is_video_album
    }
  }
  ${MatchesAlbumDetails}
  ${AlbumRootAlbumFolderBaseDetails}
  ${WebGalleryAlbumCustomPrintFields}
`;

export const AlbumForWebGalleriesFolder = gql`
  query AlbumForWebGalleriesFolder($id: RecordID!) {
    album(id: $id) {
      id
      root_album_folder {
        id
      }
    }
  }
`;

export const AlbumForWebGalleriesPurchases = gql`
  query AlbumForWebGalleriesPurchases(
    $id: RecordID!
    $album_folder_id: RecordID
  ) {
    album(id: $id) {
      ...WebGalleryAlbumBaseDetails
      ...WebGalleryAlbumPrices
      ...AlbumWatermarkConfig
      ...WebGalleryAlbumPurchasedPhotoDownloads
      album_folder {
        id
        name
        individual_albums
        price {
          value
          currency
        }
      }
      cover_photo {
        id
        faces_box
        thumbnail_urls {
          ...PhotoUrlTypeFields
        }
      }
      root_album_folder {
        id
        name
        join_code
        account_has_onboarded
        individual_albums
        price {
          value
        }
        album_type
        album_price_mode
        joins_enabled
        hero_image {
          id
          url
        }
        is_web_gallery
        web_gallery_price_per_photo {
          value
          currency
        }
        all_photos_mode
        auto_contributor_share_url
        auto_contributor_settings {
          ...AutoContributorSettingsDetails
        }
        start_date
        discount_template {
          ...DiscountTemplateDetails
        }
        ...AlbumFolderPurchaseDetails
      }
      creator {
        ...WebGalleryAccountDetailsWithImageAssets
      }
      ...WebGalleryAlbumCustomPrintFields
      ...WebGalleryAlbumAccessFields
      auto_contributor_share_url
      auto_contributor_settings {
        ...AutoContributorSettingsDetails
      }
      price_whole_album {
        value
        currency
      }
      all_photos_mode
      green_screen_enabled
      has_all_photos_access(for_web_gallery: true, use_all_photos_mode: true)
      is_video_album
    }
  }
  ${WebGalleryAlbumBaseDetails}
  ${AlbumWatermarkConfig}
  ${WebGalleryAccountDetailsWithImageAssets}
  ${WebGalleryAlbumPrices}
  ${WebGalleryAlbumPurchasedPhotoDownloads}
  ${WebGalleryAlbumCustomPrintFields}
  ${WebGalleryAlbumAccessFields}
  ${AutoContributorSettingsDetails}
  ${AlbumFolderPurchaseDetails}
  ${DiscountTemplateDetails}
`;

export const AlbumForPurchasingOptionsCheck = gql`
  query AlbumForPurchasingOptionsCheck($id: RecordID!) {
    album(id: $id) {
      id
      album_subtype
      search_subscription_credits_joins_enabled
      web_gallery_print_purchases_enabled
      pre_paid: is_demo
      price_whole_album {
        value
      }
      album_print_packages(slice: { limit: 1 }) {
        total
        records {
          id
        }
      }
      root_album_folder {
        id
        price {
          value
        }
        album_folder_print_packages(slice: { limit: 1 }) {
          total
          records {
            id
          }
        }
        album_custom_prints(
          slice: { limit: 1 }
          custom_print_types: [CUSTOM_PRINT]
          custom_print_subtype: null
        ) {
          total
        }
        specialty_custom_prints: album_custom_prints(
          slice: { limit: 1 }
          custom_print_types: [CUSTOM_PRINT]
          custom_print_subtype: SPECIALTY_PRINT
        ) {
          total
        }
        photo_pricing {
          id
        }
        digital_bundles {
          total
        }
      }
    }
  }
`;

export const AlbumForPrintBackgrounds = gql`
  query AlbumForPrintBackgrounds($id: RecordID!) {
    album(id: $id) {
      id
      root_album_folder {
        id
        ...AlbumFolderForPrintAssetDetails
      }
    }
  }
  ${AlbumFolderForPrintAssetDetails}
`;
